/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListRunsPathParams = NonNullable<operations['listRuns']['parameters']['path']>;

export type ListRunsQueryParams = NonNullable<operations['listRuns']['parameters']['query']>;

export interface Input extends ListRunsPathParams {
  apiVersion?: string;
  query?: ListRunsQueryParams;
}

export async function listRuns(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/evaluations/runs', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
